<template>
  <div>
    <div>
      <div class="card-header">
        <div class="row">
          <div class="col-md-11">
            <h4>Gestión de evoluciones atrasadas</h4>
            <p>
              Aquí podrá gestionar la información relacionada con las
              <span class="text-success">evoluciones</span> registradas en una fecha posterior a la sesión
            </p>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-4">
          <label for="fechaInicial">Fecha inicial:</label>
          <input type="date" class="form-control" v-model="fechaInicial" id="fechaInicial">
        </div>
        <div class="col-md-4">
          <label for="fechaFinal">Fecha final:</label>
          <input type="date" class="form-control"   v-model="fechaFinal" id="fechaFinal">
        </div>
        <div class="col-md-4">
          <br>
          <button class="btn btn-success btn-fill" @click="obtenerInformacionEvoluciones(fechaInicial, fechaFinal)">Buscar información</button>
        </div>
      </div>

     
      <br />
      <br />
      <div class="card">
        <div class="row">
          <div class="col-md-12">
            <download-excel
              class="btn btn-secondary btn-fill mb-2"
              :data="json_data"
              :fields="json_fields"
              worksheet="Evoluciones atrasadas"
              :name="`evoluciones_atrasadas`"
              v-if="json_data != ''"
            >
              Exportar a excel <i color="black" class="fa fa-download"></i>
            </download-excel>
            <br />
          </div> <br> <br> <br>
        </div>
        <div class="row" v-if="queriedData2 == ''">
          <center>
            <div class="col-md-12">
              <center>
                <img
                  src="/static/img/ICONOS/estadisticas.svg"
                  alt="Imagen de datos vacios"
                  width="70"
                />
                <p class="titulo-mensaje">Aún no hay datos para mostrar.</p>
              </center>
            </div>
          </center>
        </div>


        <div class="row" style="padding-left: 15px" v-if="queriedData2 != ''">
          <div class="col-3">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <br />
            <br />
            <el-table
              border
              :data="queriedData"
              class="table-responsive table-striped mt-2"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
                <template slot-scope="{ row }">
                  <div :class="getClass(column, row)" class="full-width">
                    <strong v-if="getClass(column, row) != ''">{{
                      formatearPesosColombianos(row[column.prop])
                    }}</strong>
                    <span v-else>{{ row[column.prop] }}</span>
                  </div>
                </template>
              </el-table-column>

              <!-- <el-table-column>
                <template slot-scope="props">
                  <center>
                    <button
                      class="btn btn-simple btn-danger btn-icon like"
                      @click="deleteExpense(props.row)"
                    >
                      <i class="ti-trash"></i>
                    </button>
                  </center>
                </template>
              </el-table-column> -->
            </el-table>
          </div>
          <div class="row" v-if="queriedData2 != ''">
          <div class="col-sm-6 pagination-info">
            <br />
            <p class="category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <div class="col-sm-6">
            <p-pagination
              class="pull-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
            ></p-pagination>
          </div>
        </div>
        </div>

        <modal
          name="registrar-gasto"
          :scrollable="true"
          height="auto"
          :reset="true"
        >
          <div class="modal-header" style="padding: 8px">
            <div class="row">
              <div class="col-md-12">
                <strong class="titulo-modal"> REGISTRAR UN GASTO FIJO </strong>
                <br />
                <span style="color: grey"> Creación de gastos fijos </span>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <form @submit.prevent="newExpense()">
              <div class="row">
                <div class="col-md-12">
                  <label for="valor">Valor del gasto:</label>
                  <input
                    type="number"
                    required
                    class="form-control"
                    v-model="valor"
                  />
                </div>
                <div class="col-md-12">
                  <label for="usuario">Usuario:</label>
                  <select  id="usuario" class="form-control" v-model="usuario">
                    <option value="">Seleccionar...</option>
                    <option v-for="usuario in listUsers" :key="usuario.id" :value="usuario.usuario"> {{  usuario.nombreUsuario }}</option>
                  </select>
                </div>
                <div class="col-md-12">
                  <label for="nota">Concepto:</label>
                  <textarea
                    v-model="nota"
                    name="nota"
                    id="nota"
                    cols="30"
                    rows="2"
                    class="form-control"
                  ></textarea>
                </div>
                <div class="col-md-12">
                  <center>
                    <br />
                    <button class="btn btn-secondary" @click="cerrarModal()">
                      Cancelar
                    </button>
                    <button type="submit" class="btn btn-success btn-fill">
                      Registrar gasto
                    </button>
                  </center>
                </div>
              </div>
            </form>
          </div>
        </modal>
      </div>
    </div>
  </div>
</template>
<script>
import axiosInstance from "src/global-services/axiosInstance";
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import JsonExcel from "vue-json-excel";
import crearAlerta from "../../global-services/crearAlerta";
import formatearPesosColombianos from "../../global-services/formatear-pesos";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
Vue.component("downloadExcel", JsonExcel);

export default {
  computed: {
    pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData() {
      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      let result = this.queriedData2.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchQuery.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    },
  },
  data: () => ({
    fechaInicial: "",
    fechaFinal: "",
    searchQuery: "",
    nota: "",
    usuario: "",
    valor: "",
    queriedData2: [],
    listUsers: [],
    tableColumns: [
      {
        prop: "terapeuta", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Terapeuta", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 120, //ANCHO DE LA COLUMNA
      },
      {
        prop: "paciente", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Paciente", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 120, //ANCHO DE LA COLUMNA
      },
      {
        prop: "tipo", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Tipo sesión", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 100, //ANCHO DE LA COLUMNA
      },
      {
        prop: "fecha", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Fecha sesión", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 100, //ANCHO DE LA COLUMNA
      },
      {
        prop: "fechaFin", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Fecha final de evolución", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 100, //ANCHO DE LA COLUMNA
      },
      {
        prop: "fechaEvolucion", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Fecha evolución", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 100, //ANCHO DE LA COLUMNA
      },
      {
        prop: "precio", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Monto descontado", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 100, //ANCHO DE LA COLUMNA
      },
    ],
    json_fields: {
      "paciente": "paciente",
      "terapeuta": "terapeuta",
      "fecha": "fecha",
      "fecha evolución": "fechaEvolucion",
      "valor descontado": "precio",
    },
    json_data: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
    sede: "Sede Principal",
    pagination: {
      perPage: 25,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50, 100, 200, 300],
      total: 0,
    },
  }),
  components: {
    PPagination,
  },
  methods: {
    formatearPesosColombianos,
    cerrarModal: function () {
      this.nota = "";
      this.valor = "";
      this.$modal.hide("registrar-gasto");
    },
    prepararRegistrar: function () {
      this.nota = "";
      this.valor = "";
      this.$modal.show("registrar-gasto");
    },
    newExpense: async function () {
      if (this.valor == "" || this.nota == "") {
        this.$notify(crearAlerta("danger", "Complete los campos requeridos"));
        return;
      }
      try {
        this.$modal.show("carga");
        const data = {
          valor: this.valor,
          nota: this.nota,
          usuario: this.usuario
        };
        const response = await axiosInstance.post("api/newExpense", data);

        if (response.data.status === true) {
          this.$notify(crearAlerta("success", response.data.mensaje));
          this.obtenerInformacionGastos();
        } else {
          this.$notify(crearAlerta("danger", response.data.mensaje));
        }
      } catch (error) {
        this.$notify(crearAlerta("danger", error));
      } finally {
        this.$modal.hide("carga");
        this.cerrarModal();
      }
    },
    async obtenerInformacionEvoluciones(fechaInicial, fechaFinal) {
      try {
        this.$modal.show("carga");
        const sede = localStorage.getItem("sede");
        const response = await axiosInstance.get(`api/evoluciones-atrasadas/${fechaInicial}/${fechaFinal}`);
        this.queriedData2 = response.data.data;
        this.json_data = response.data.data;
      } catch (error) {
        this.$notify(crearAlerta("danger", error));
      } finally {
        this.$modal.hide("carga");
      }
    },
    deleteExpense: async function (gasto) {
      try {
        this.$modal.show("carga");
        const data = { id: gasto.id };
        const response = await axiosInstance.post(`api/deleteExpense`, data);

        if (response.data.status === true) {
          this.$notify(crearAlerta("success", response.data.mensaje));
          this.obtenerInformacionGastos();
        } else {
          this.$notify(crearAlerta("danger", response.data.mensaje));
        }
      } catch (error) {
        this.$notify(crearAlerta("danger", error));
      } finally {
        this.$modal.hide("carga");
      }
    },
    getListUsers: async function () {
      try {
        this.$modal.show("carga");
        const response = await axiosInstance.get(`api/get-list-users`);

        if (response.data.status === true) {
          this.listUsers= response.data.data;
        } else {
          this.$notify(crearAlerta("danger", response.data.mensaje));
        }
      } catch (error) {
        this.$notify(crearAlerta("danger", error));
      } finally {
        this.$modal.hide("carga");
      }
    },
    getClass(column, row) {
      if (column.prop === "precio") {
        return "low-percentage";
      }
      return "";
    },
  },
  mounted() {
    this.rol = localStorage.getItem("rol");
    if (localStorage.getItem("rol") != 1) {
      this.sede = localStorage.getItem("sede");
    }
    document.title = "Avanti | Gestión de descargos";
    // this.obtenerInformacionEvoluciones();
    // this.getListUsers();
  },
};
</script>
  
<style>
.card {
  box-shadow: 0 0 0 0;
  border-radius: 15px;
  padding: 2%;
}

.btn {
  border-radius: 5px;
}

.high-percentage {
  background-color: #a0e2b3;
  /* color: white !important; */
}

.medium-percentage {
  background-color: #f2e3b0;
  /* color: black; */
}

.low-percentage {
  background-color: #fb817e;
  /* color: white; */
}

.full-width {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  /* padding: 15px; Si quieres mantener el padding interno */
}

.el-table__cell {
  height: 20px !important;
}
</style>
    
    


// WEBPACK FOOTER //
// src/components/ADashboard/gastosFijos.vue